import { mapKeysToCamelCase } from '@skytech/utils'

import { API_ROUTE_ADMIN_REPORTS } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { ReportFilters } from './types'

type TaxAdvantageReportOriginal = {
  name: string
  employee_no: string | null
  id: number
  salary_deduction_amount: number
  content_service_amount: number
  benefit_amount: string
  amount: number
  vat: number
  benefit_mobile: string
  org_no: string
  company: string
  start_month: string
  end_month: string
  month_no: number
  tax_tmp: number
  tax_amount: number
}

const IS_NEW_BACKEND_API = true

export const getTaxAdvantageReports = async ({
  selectedReportType,
  year,
  isGlobal,
  selectedCustomer,
}: ReportFilters) => {
  if (!year) throw Error('Missing year filter!')

  const searchParams = new URLSearchParams()
  searchParams.append('year', year.toString())
  searchParams.append('isGlobal', isGlobal.toString())
  searchParams.append('customerId', String(selectedCustomer || ''))

  const reports = await get<TaxAdvantageReportOriginal[]>(
    `${API_ROUTE_ADMIN_REPORTS}/${selectedReportType}?${searchParams.toString()}`,
    IS_NEW_BACKEND_API
  )

  return mapKeysToCamelCase(reports)
}
